import { map } from 'rxjs/operators';
import { Injector } from '@angular/core';
import { LegalEntitiesApi, LegalEntitiesGroupApiClient } from '@sg/api/legal-entities-api';

import { SgEntityFetchAdapter } from '../components/entity-select-auto-complete';

declare module '../components/entity-select-auto-complete/entity-select-fetch-store.service' {
  export interface SgEntitySelectEntityFetchMap {
    LegalEntityGroup: {
      entity: LegalEntitiesApi.LegalEntitiesGroupDto;
      query: LegalEntitiesApi.SearchLegalEntitiesGroupsRequest;
    };
  }
}

export class LegalEntityGroupApiToEntityFetcherLink implements SgEntityFetchAdapter<'LegalEntityGroup'> {
  readonly key: 'LegalEntityGroup' = 'LegalEntityGroup';
  readonly metadata: {
    idField: keyof LegalEntitiesApi.LegalEntitiesGroupDto;
    labelField: keyof LegalEntitiesApi.LegalEntitiesGroupDto;
    queryField?: { field: keyof LegalEntitiesApi.SearchLegalEntitiesGroupsRequest; isArray?: boolean };
  } = {
    idField: 'legalEntitiesGroupId',
    labelField: 'name',
    queryField: { field: 'name' },
  };

  private readonly legalEntitiesGroupApi: LegalEntitiesGroupApiClient;

  constructor(injector: Injector) {
    this.legalEntitiesGroupApi = injector.get(LegalEntitiesGroupApiClient);
  }

  getEntity(id: string) {
    return this.legalEntitiesGroupApi.legalEntitiesGroupsControllerGetLegalEntityGroupById({ id }, { observe: 'body' });
  }

  findEntities(query?: LegalEntitiesApi.SearchLegalEntitiesGroupsRequest, pageNumber?: number) {
    const body: LegalEntitiesApi.SearchLegalEntitiesGroupsRequest = {};

    if (query) {
      Object.assign(body, query);
    }

    return this.legalEntitiesGroupApi
      .legalEntitiesGroupsControllerGetLegalEntityGroupBySearchParams(
        { body, pageSize: 10, pageNumber: pageNumber ?? 1 },
        { observe: 'body' }
      )
      .pipe(
        map((result) => {
          return {
            data: result.rows ? result.rows : [],
            infiniteScrollInfo: { currentPage: result.paging.pageNumber, totalPages: result.paging.totalPages },
          };
        })
      );
  }
}
